// Get the modal
var bundle_model = document.getElementById("bundle_model");
var bundle_body = document.querySelector("body");

// Get the button that opens the modal
var add_custom_bundle = document.getElementById("add_custom_bundle");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal
add_custom_bundle.onclick = function () {
  bundle_model.style.display = "block";
  bundle_body.classList.add("bundle_model_body");
};

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  bundle_model.style.display = "none";
  bundle_body.classList.remove("bundle_model_body");

  $("#choose-bundle-type").show();
  $("#bundle-product-product").hide();
  $(".bundle-demo-drawer-grid").html("");
  $(".bundle-product-collection").hide();
  $(".bundle-chain").show();

  $('#bundle-product-product').removeClass('bundle-product-complete');
  $(".product_bundle_variant").val("");
};

// When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == bundle_model) {
//     bundle_model.style.display = "none";
//   }
// }

function fnShowSecondStep(d) {
  var currentStep = document.getElementById("currentStep");
  var currentStepValue = currentStep.value;
  var currentType = d.getAttribute("data-type");

  var dummyChainProductStr = "";
  dummyChainProductStr += '<div class="bundle-demo-drawer-item">';
  dummyChainProductStr += '<div class="demo-drawer-product">';
  dummyChainProductStr +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyChainProductStr += '<button class="bundle-product-close chian-close" onclick="fnPreviewClose(1)">';
  dummyChainProductStr +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyChainProductStr += "</button>";
  dummyChainProductStr += '<div class="demo-drawer-product-media chain-media">';
  dummyChainProductStr +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Chain_Vector.png?v=1679658387">';
  dummyChainProductStr += "</div>";
  dummyChainProductStr +=
    '<h4 class="demo-drawer-product-title chain-title">CHAIN</h4>';
  dummyChainProductStr += "</a>";
  dummyChainProductStr += "</div>";
  dummyChainProductStr += "</div>";
  dummyChainProductStr += '<input type="hidden" id="proChainValue" value="">';
  dummyChainProductStr += '<input type="hidden" id="proChainPrice" value="">';
  dummyChainProductStr += '<input type="hidden" id="proChainVariantId" value="">';

  var dummyChainProductStr2 = "";
  dummyChainProductStr2 += '<div class="bundle-demo-drawer-item">';
  dummyChainProductStr2 += '<div class="demo-drawer-product">';
  dummyChainProductStr2 +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyChainProductStr2 += '<button class="bundle-product-close chian2-close" onclick="fnPreviewClose(2)">';
  dummyChainProductStr2 +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyChainProductStr2 += "</button>";
  dummyChainProductStr2 +=
    '<div class="demo-drawer-product-media chain2-media">';
  dummyChainProductStr2 +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Chain_Vector.png?v=1679658387">';
  dummyChainProductStr2 += "</div>";
  dummyChainProductStr2 +=
    '<h4 class="demo-drawer-product-title chain2-title">CHAIN #2</h4>';
  dummyChainProductStr2 += "</a>";
  dummyChainProductStr2 += "</div>";
  dummyChainProductStr2 += "</div>";
  dummyChainProductStr2 += '<input type="hidden" id="proChain2Value" value="">';
  dummyChainProductStr2 += '<input type="hidden" id="proChain2Price" value="">';
  dummyChainProductStr2 += '<input type="hidden" id="proChain2VariantId" value="">';

  var dummyBraceletProductStr = "";
  dummyBraceletProductStr += '<div class="bundle-demo-drawer-item">';
  dummyBraceletProductStr += '<div class="demo-drawer-product">';
  dummyBraceletProductStr +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyBraceletProductStr += '<button class="bundle-product-close bracelet-close" onclick="fnPreviewClose(3)">';
  dummyBraceletProductStr +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyBraceletProductStr += "</button>";
  dummyBraceletProductStr +=
    '<div class="demo-drawer-product-media bracelet-media">';
  dummyBraceletProductStr +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Bracelet_Vector.png?v=1679658387">';
  dummyBraceletProductStr += "</div>";
  dummyBraceletProductStr +=
    '<h4 class="demo-drawer-product-title bracelet-title">BRACELET</h4>';
  dummyBraceletProductStr += "</a>";
  dummyBraceletProductStr += "</div>";
  dummyBraceletProductStr += "</div>";
  dummyBraceletProductStr +=
    '<input type="hidden" id="proBracheletValue" value="">';
  dummyBraceletProductStr +=
    '<input type="hidden" id="proBracheletPrice" value="">';
  dummyBraceletProductStr += '<input type="hidden" id="proBracheletVariantId" value="">';

  var dummyBraceletProductStr2 = "";
  dummyBraceletProductStr2 += '<div class="bundle-demo-drawer-item">';
  dummyBraceletProductStr2 += '<div class="demo-drawer-product">';
  dummyBraceletProductStr2 +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyBraceletProductStr2 += '<button class="bundle-product-close bracelet2-close" onclick="fnPreviewClose(4)">';
  dummyBraceletProductStr2 +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyBraceletProductStr2 += "</button>";
  dummyBraceletProductStr2 +=
    '<div class="demo-drawer-product-media bracelet2-media">';
  dummyBraceletProductStr2 +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Bracelet_Vector.png?v=1679658387">';
  dummyBraceletProductStr2 += "</div>";
  dummyBraceletProductStr2 +=
    '<h4 class="demo-drawer-product-title bracelet2-title">BRACELET #2</h4>';
  dummyBraceletProductStr2 += "</a>";
  dummyBraceletProductStr2 += "</div>";
  dummyBraceletProductStr2 += "</div>";
  dummyBraceletProductStr2 +=
    '<input type="hidden" id="proBrachelet2Value" value="">';
  dummyBraceletProductStr2 +=
    '<input type="hidden" id="proBrachelet2Price" value="">';
  dummyBraceletProductStr2 += '<input type="hidden" id="proBrachelet2VariantId" value="">';

  var dummyEarringsProductStr = "";
  dummyEarringsProductStr += '<div class="bundle-demo-drawer-item">';
  dummyEarringsProductStr += '<div class="demo-drawer-product">';
  dummyEarringsProductStr +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyEarringsProductStr += '<button class="bundle-product-close earrings-close" onclick="fnPreviewClose(5)">';
  dummyEarringsProductStr +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyEarringsProductStr += "</button>";
  dummyEarringsProductStr +=
    '<div class="demo-drawer-product-media earrings-media">';
  dummyEarringsProductStr +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Earrings.webp?v=1679897709">';
  dummyEarringsProductStr += "</div>";
  dummyEarringsProductStr +=
    '<h4 class="demo-drawer-product-title earrings-title">EARRINGS</h4>';
  dummyEarringsProductStr += "</a>";
  dummyEarringsProductStr += "</div>";
  dummyEarringsProductStr += "</div>";
  dummyEarringsProductStr +=
    '<input type="hidden" id="proEarringValue" value="">';
  dummyEarringsProductStr +=
    '<input type="hidden" id="proEarringPrice" value="">';
  dummyEarringsProductStr += '<input type="hidden" id="proEarringVariantId" value="">';

  var dummyRingProductStr = "";
  dummyRingProductStr += '<div class="bundle-demo-drawer-item">';
  dummyRingProductStr += '<div class="demo-drawer-product">';
  dummyRingProductStr +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyRingProductStr += '<button class="bundle-product-close ring-close" onclick="fnPreviewClose(6)">';
  dummyRingProductStr +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyRingProductStr += "</button>";
  dummyRingProductStr += '<div class="demo-drawer-product-media ring-media">';
  dummyRingProductStr +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Ring_Vector.png?v=1679658387">';
  dummyRingProductStr += "</div>";
  dummyRingProductStr +=
    '<h4 class="demo-drawer-product-title ring-title">RING</h4>';
  dummyRingProductStr += "</a>";
  dummyRingProductStr += "</div>";
  dummyRingProductStr += "</div>";
  dummyRingProductStr += '<input type="hidden" id="proRingValue" value="">';
  dummyRingProductStr += '<input type="hidden" id="proRingPrice" value="">';
  dummyRingProductStr += '<input type="hidden" id="proRingVariantId" value="">';

  var dummyPendantProductStr = "";
  dummyPendantProductStr += '<div class="bundle-demo-drawer-item">';
  dummyPendantProductStr += '<div class="demo-drawer-product">';
  dummyPendantProductStr +=
    '<a class="demo-drawer-product-type" href="javascript:void(0);">';
  dummyPendantProductStr += '<button class="bundle-product-close pendant-close" onclick="fnPreviewClose(7)">';
  dummyPendantProductStr +=
    '<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNTIgNTEyIj48cGF0aCBmaWxsPSIjNEE0OTQ1IiBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiI+PC9wYXRoPjwvc3ZnPg==" class="close-icon">';
  dummyPendantProductStr += "</button>";
  dummyPendantProductStr +=
    '<div class="demo-drawer-product-media pendant-media">';
  dummyPendantProductStr +=
    '<img src="https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Pendant_Vector.webp?v=1679897759">';
  dummyPendantProductStr += "</div>";
  dummyPendantProductStr +=
    '<h4 class="demo-drawer-product-title pendant-title">PENDANT</h4>';
  dummyPendantProductStr += "</a>";
  dummyPendantProductStr += "</div>";
  dummyPendantProductStr += "</div>";
  dummyPendantProductStr +=
    '<input type="hidden" id="proPendantValue" value="">';
  dummyPendantProductStr +=
    '<input type="hidden" id="proPendantPrice" value="">';
  dummyPendantProductStr += '<input type="hidden" id="proPendantVariantId" value="">';

  if (currentStepValue == 1) {
    $("#choose-bundle-type").hide();
    $("#bundle-product-product").show();

    $("#currentBundle").val(currentType);
    if (currentType == 1) {
      //Chain + Bracelet
      // $(".bundle-demo-drawer-grid").append(
      //   dummyChainProductStr + dummyBraceletProductStr
      // );
      $('.bundle-demo-drawer-item').hide();
      $('.chain-dummy').show();
      $('.bracelet-dummy').show();

      $('.hidden_val').val('');
    }
    if (currentType == 2) {
      //2 Chains + 1 Pendant
      // $(".bundle-demo-drawer-grid").append(
      //   dummyChainProductStr + dummyChainProductStr2 + dummyPendantProductStr
      // );
      $('.bundle-demo-drawer-item').hide();
      $('.chain-dummy').show();
      $('.chain2-dummy').show();
      $('.pendant-dummy').show();

      $('.hidden_val').val('');
    }
    if (currentType == 3) {
      //2 Chains + 2 Bracelets
      // $(".bundle-demo-drawer-grid").append(
      //   dummyChainProductStr +
      //     dummyChainProductStr2 +
      //     dummyBraceletProductStr +
      //     dummyBraceletProductStr2
      // );
      $('.bundle-demo-drawer-item').hide();
      $('.chain-dummy').show();
      $('.chain2-dummy').show();
      $('.bracelet-dummy').show();
      $('.bracelet2-dummy').show();

      $('.hidden_val').val('');
    }
    if (currentType == 4) {
      //Chain + Bracelet + Ring
      // $(".bundle-demo-drawer-grid").append(
      //   dummyChainProductStr + dummyBraceletProductStr + dummyRingProductStr
      // );
      $('.bundle-demo-drawer-item').hide();
      $('.chain-dummy').show();
      $('.bracelet-dummy').show();
      $('.ring-dummy').show();

      $('.hidden_val').val('');
    }
    if (currentType == 5) {
      //Chain + Bracelet + Earrings
      // $(".bundle-demo-drawer-grid").append(
      //   dummyChainProductStr + dummyBraceletProductStr + dummyEarringsProductStr
      // );
      $('.bundle-demo-drawer-item').hide();
      $('.chain-dummy').show();
      $('.bracelet-dummy').show();
      $('.earrings-dummy').show();
      
      $('.hidden_val').val('');
    }

    $(".bundle-product-collection").hide();
    $(".bundle-chain").show();
  }
}

function fuUpdatePrice() {
  $(".bundle-total-wrapper").show();

  var proChainValue = $("#proChainPrice").val();
  var proChain2Value = $("#proChain2Price").val();
  var proBraceletPrice = $("#proBracheletPrice").val();
  var proBracelet2Price = $("#proBrachelet2Price").val();
  var proEarringPrice = $("#proEarringPrice").val();
  var proRingPrice = $("#proRingPrice").val();
  var proPendantPrice = $("#proPendantPrice").val();
  
  if (typeof proChainValue === "undefined" || proChainValue == '') {
    proChainValue = 0;
  }
  if (typeof proChain2Value === "undefined" || proChain2Value == '') {
    proChain2Value = 0;
  }
  if (typeof proBraceletPrice === "undefined" || proBraceletPrice == '') {
    proBraceletPrice = 0;
  }
  if (typeof proBracelet2Price === "undefined" || proBracelet2Price == '') {
    proBracelet2Price = 0;
  } 
  if (typeof proEarringPrice === "undefined" || proEarringPrice == '') {
    proEarringPrice = 0;
  }
  if (typeof proRingPrice === "undefined" || proRingPrice == '') {
    proRingPrice = 0;
  }
  if (typeof proPendantPrice === "undefined" || proPendantPrice == '') {
    proPendantPrice = 0;
  }
  var totalPrice = eval(proChainValue) + eval(proChain2Value) + eval(proBraceletPrice) + eval(proBracelet2Price) + eval(proEarringPrice) + eval(proRingPrice) + eval(proPendantPrice);
  $('.bundle-price-lineover span').html('$'+eval(totalPrice).toFixed(2));
  var discountAmount = (eval(totalPrice) * 20) / 100;
  $('.bundle-price-totalsave').html(' Savings: $'+discountAmount.toFixed(2));
  var discountPrice = eval(totalPrice) - eval(discountAmount);
  $('.bundle-price span').html('$'+eval(discountPrice).toFixed(2));
}

$(".chain.product_bundle_variant").on("change", function () {
  var variantId = this.value;
  var element = $(this).find("option:selected");
  var chainSku = element.attr("data-sku");
  var chainPrice = element.attr("data-price");
  var chainPriceWithout = element.attr("data-pricewithout");
  var chainTitle = element.attr("data-title");
  var chainImg = element.attr("data-img");
  
  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 1) {
    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();

    if ($("#proBracheletValue").val() == "") {
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }
    else{
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    
    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);
  }
  if (currentBundle == 2) {
    if ($("#proChainValue").val() == "") {
      $("#proChainValue").val(1);
      $("#proChainPrice").val(chainPriceWithout);
      $("#proChainVariantId").val(variantId);

      if ($("#proChain2Value").val() == "1" && $("#proPendantValue").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        fnMobileExtraClass('active');
      }
      
      $(".chain-media img").attr("src", chainImg);
      $(".chain-title").html(chainTitle);
      $('.chian-close').show();
    } else if ($("#proChain2Value").val() == "") {
      $("#proChain2Value").val(1);
      $("#proChain2Price").val(chainPriceWithout);
      $("#proChain2VariantId").val(variantId);

      if ($("#proPendantValue").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        $(".bundle-product-collection").hide();
        $(".bundle-pendant").show();
        fnMobileExtraClass('active');
      }

      $(".chain2-media img").attr("src", chainImg);
      $(".chain2-title").html(chainTitle);
      $('.chian2-close').show();
    }
  }
  if (currentBundle == 3) {
    if ($("#proChainValue").val() == "") {
      $("#proChainValue").val(1);
      $("#proChainPrice").val(chainPriceWithout);
      $("#proChainVariantId").val(variantId);

      if ($("#proChain2Value").val() == "1" && $("#proBracheletValue").val() == "1" && $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        fnMobileExtraClass('active');
      }
      
      $(".chain-media img").attr("src", chainImg);
      $(".chain-title").html(chainTitle);
      $('.chian-close').show();
    } else if ($("#proChain2Value").val() == "") {
      $("#proChain2Value").val(1);
      $("#proChain2Price").val(chainPriceWithout);
      $("#proChain2VariantId").val(variantId);

      if ( $("#proBracheletValue").val() == "1" && $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        $(".bundle-product-collection").hide();
        $(".bundle-bracelet").show();
        fnMobileExtraClass('active');
      }

      $(".chain2-media img").attr("src", chainImg);
      $(".chain2-title").html(chainTitle);
      $('.chian2-close').show();
    }
  }
  if (currentBundle == 4) {
    if ($("#proBracheletValue").val() == "1" && $("#proRingValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }

    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);

    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();
  }
  if (currentBundle == 5) {
    if ($("#proBracheletValue").val() == "1" && $("#proEarringValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }

    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);

    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();
  }

  fuUpdatePrice();
});

$(".bracelet.product_bundle_variant").on("change", function () {
  var variantId = this.value;
  var element = $(this).find("option:selected");
  var braceletSku = element.attr("data-sku");
  var braceletPrice = element.attr("data-price");
  var braceletPriceWithout = element.attr("data-pricewithout");
  var braceletTitle = element.attr("data-title");
  var braceletImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 1) {
    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);
  }
  if (currentBundle == 3) {
    if ($("#proBracheletValue").val() == "") {
      $("#proBracheletValue").val(1);
      $("#proBracheletPrice").val(braceletPriceWithout);
      $("#proBracheletVariantId").val(variantId);

      if ( $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      
      $(".bracelet-media img").attr("src", braceletImg);
      $(".bracelet-title").html(braceletTitle);
      $('.bracelet-close').show();
    } else if ($("#proBrachelet2Value").val() == "") {
      $("#proBrachelet2Value").val(1);
      $("#proBrachelet2Price").val(braceletPriceWithout);
      $("#proBrachelet2VariantId").val(variantId);

      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');

      $(".bracelet2-media img").attr("src", braceletImg);
      $(".bracelet2-title").html(braceletTitle);
      $('.bracelet2-close').show();
    }
  }
  if (currentBundle == 4) {
    if ($("#proRingValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-ring").show();
      fnMobileExtraClass('active');
    }

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);

    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();
  }
  if (currentBundle == 5) {
    if ($("#proEarringValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-earrings").show();
     fnMobileExtraClass('active'); 
    }

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);

    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();
  }

  fuUpdatePrice();
});

$(".ring.product_bundle_variant").on("change", function () {
  var variantId = this.value;
  var element = $(this).find("option:selected");
  var ringSku = element.attr("data-sku");
  var ringPrice = element.attr("data-price");
  var ringPriceWithout = element.attr("data-pricewithout");
  var ringTitle = element.attr("data-title");
  var ringImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 4) {
    $("#proRingValue").val(1);
    $("#proRingPrice").val(ringPriceWithout);
    $("#proRingVariantId").val(variantId);

    $(".ring-media img").attr("src", ringImg);
    $(".ring-title").html(ringTitle);
    $('.ring-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");

    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

$(".pendant.product_bundle_variant").on("change", function () {
  var variantId = this.value;
  var element = $(this).find("option:selected");
  var pendantSku = element.attr("data-sku");
  var pendantPrice = element.attr("data-price");
  var pendantPriceWithout = element.attr("data-pricewithout");
  var pendantTitle = element.attr("data-title");
  var pendantImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 2) {
    $("#proPendantValue").val(1);
    $("#proPendantPrice").val(pendantPriceWithout);
    $("#proPendantVariantId").val(variantId);

    $(".pendant-media img").attr("src", pendantImg);
    $(".pendant-title").html(pendantTitle);
    $('.pendant-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

$(".earrings.product_bundle_variant").on("change", function () {
  var variantId = this.value;
  var element = $(this).find("option:selected");
  var earringsSku = element.attr("data-sku");
  var earringsPrice = element.attr("data-price");
  var earringsPriceWithout = element.attr("data-pricewithout");
  var earringsTitle = element.attr("data-title");
  var earringsImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 5) {
    $("#proEarringValue").val(1);
    $("#proEarringPrice").val(pendantPriceWithout);
    $("#proEarringVariantId").val(variantId);

    $(".earrings-media img").attr("src", earringsImg);
    $(".earrings-title").html(earringsTitle);
    $('.earrings-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

$(".chain.single_variant").on("click", function () {
  var variantId = this.value;
  var element = $(this);
  var chainSku = element.attr("data-sku");
  var chainPrice = element.attr("data-price");
  var chainPriceWithout = element.attr("data-pricewithout");
  var chainTitle = element.attr("data-title");
  var chainImg = element.attr("data-img");
  
  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 1) {
    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();

    if ($("#proBracheletValue").val() == "") {
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }
    else{
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    
    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);
  }
  if (currentBundle == 2) {
    if ($("#proChainValue").val() == "") {
      $("#proChainValue").val(1);
      $("#proChainPrice").val(chainPriceWithout);
      $("#proChainVariantId").val(variantId);

      if ($("#proChain2Value").val() == "1" && $("#proPendantValue").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        fnMobileExtraClass('active');
      }
      
      $(".chain-media img").attr("src", chainImg);
      $(".chain-title").html(chainTitle);
      $('.chian-close').show();
    } else if ($("#proChain2Value").val() == "") {
      $("#proChain2Value").val(1);
      $("#proChain2Price").val(chainPriceWithout);
      $("#proChain2VariantId").val(variantId);

      if ($("#proPendantValue").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        $(".bundle-product-collection").hide();
        $(".bundle-pendant").show();
        fnMobileExtraClass('active');
      }

      $(".chain2-media img").attr("src", chainImg);
      $(".chain2-title").html(chainTitle);
      $('.chian2-close').show();
    }
  }
  if (currentBundle == 3) {
    if ($("#proChainValue").val() == "") {
      $("#proChainValue").val(1);
      $("#proChainPrice").val(chainPriceWithout);
      $("#proChainVariantId").val(variantId);

      if ($("#proChain2Value").val() == "1" && $("#proBracheletValue").val() == "1" && $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        fnMobileExtraClass('active');
      }
      
      $(".chain-media img").attr("src", chainImg);
      $(".chain-title").html(chainTitle);
      $('.chian-close').show();
    } else if ($("#proChain2Value").val() == "") {
      $("#proChain2Value").val(1);
      $("#proChain2Price").val(chainPriceWithout);
      $("#proChain2VariantId").val(variantId);

      if ( $("#proBracheletValue").val() == "1" && $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      else{
        $(".bundle-product-collection").hide();
        $(".bundle-bracelet").show();
        fnMobileExtraClass('active');
      }

      $(".chain2-media img").attr("src", chainImg);
      $(".chain2-title").html(chainTitle);
      $('.chian2-close').show();
    }
  }
  if (currentBundle == 4) {
    if ($("#proBracheletValue").val() == "1" && $("#proRingValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }

    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);

    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();
  }
  if (currentBundle == 5) {
    if ($("#proBracheletValue").val() == "1" && $("#proEarringValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-bracelet").show();
      fnMobileExtraClass('active');
    }

    $("#proChainValue").val(1);
    $("#proChainPrice").val(chainPriceWithout);
    $("#proChainVariantId").val(variantId);

    $(".chain-media img").attr("src", chainImg);
    $(".chain-title").html(chainTitle);
    $('.chian-close').show();
  }

  fuUpdatePrice();
});

$(".bracelet.single_variant").on("click", function () {
  var variantId = this.value;
  var element = $(this);
  var braceletSku = element.attr("data-sku");
  var braceletPrice = element.attr("data-price");
  var braceletPriceWithout = element.attr("data-pricewithout");
  var braceletTitle = element.attr("data-title");
  var braceletImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 1) {
    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);
  }
  if (currentBundle == 3) {
    if ($("#proBracheletValue").val() == "") {
      $("#proBracheletValue").val(1);
      $("#proBracheletPrice").val(braceletPriceWithout);
      $("#proBracheletVariantId").val(variantId);

      if ( $("#proBrachelet2Value").val() == "1"){
        $("#bundle-product-product").addClass("bundle-product-complete");
        $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
        fnMobileExtraClass('active-full');
      }
      
      $(".bracelet-media img").attr("src", braceletImg);
      $(".bracelet-title").html(braceletTitle);
      $('.bracelet-close').show();
    } else if ($("#proBrachelet2Value").val() == "") {
      $("#proBrachelet2Value").val(1);
      $("#proBrachelet2Price").val(braceletPriceWithout);
      $("#proBrachelet2VariantId").val(variantId);

      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');

      $(".bracelet2-media img").attr("src", braceletImg);
      $(".bracelet2-title").html(braceletTitle);
      $('.bracelet2-close').show();
    }
  }
  if (currentBundle == 4) {
    if ($("#proRingValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-ring").show();
      fnMobileExtraClass('active');
    }

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);

    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();
  }
  if (currentBundle == 5) {
    if ($("#proEarringValue").val() == "1"){
      $("#bundle-product-product").addClass("bundle-product-complete");
      $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
      fnMobileExtraClass('active-full');
    }
    else{
      $(".bundle-product-collection").hide();
      $(".bundle-earrings").show();
     fnMobileExtraClass('active'); 
    }

    $("#proBracheletValue").val(1);
    $("#proBracheletPrice").val(braceletPriceWithout);
    $("#proBracheletVariantId").val(variantId);

    $(".bracelet-media img").attr("src", braceletImg);
    $(".bracelet-title").html(braceletTitle);
    $('.bracelet-close').show();
  }

  fuUpdatePrice();
});

$(".ring.single_variant").on("click", function () {
  var variantId = this.value;
  var element = $(this);
  var ringSku = element.attr("data-sku");
  var ringPrice = element.attr("data-price");
  var ringPriceWithout = element.attr("data-pricewithout");
  var ringTitle = element.attr("data-title");
  var ringImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 4) {
    $("#proRingValue").val(1);
    $("#proRingPrice").val(ringPriceWithout);
    $("#proRingVariantId").val(variantId);

    $(".ring-media img").attr("src", ringImg);
    $(".ring-title").html(ringTitle);
    $('.ring-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");

    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

$(".pendant.single_variant").on("click", function () {
  var variantId = this.value;
  var element = $(this);
  var pendantSku = element.attr("data-sku");
  var pendantPrice = element.attr("data-price");
  var pendantPriceWithout = element.attr("data-pricewithout");
  var pendantTitle = element.attr("data-title");
  var pendantImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 2) {
    $("#proPendantValue").val(1);
    $("#proPendantPrice").val(pendantPriceWithout);
    $("#proPendantVariantId").val(variantId);

    $(".pendant-media img").attr("src", pendantImg);
    $(".pendant-title").html(pendantTitle);
    $('.pendant-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

$(".earrings.single_variant").on("click", function () {
  var variantId = this.value;
  var element = $(this);
  var earringsSku = element.attr("data-sku");
  var earringsPrice = element.attr("data-price");
  var earringsPriceWithout = element.attr("data-pricewithout");
  var earringsTitle = element.attr("data-title");
  var earringsImg = element.attr("data-img");

  var currentBundle = $("#currentBundle").val();
  if (currentBundle == 5) {
    $("#proEarringValue").val(1);
    $("#proEarringPrice").val(earringsPriceWithout);
    $("#proEarringVariantId").val(variantId);

    $(".earrings-media img").attr("src", earringsImg);
    $(".earrings-title").html(earringsTitle);
    $('.earrings-close').show();

    $("#bundle-product-product").addClass("bundle-product-complete");
    $(".bundle-demo-drawer h2").html("YOUR BUNDLE IS COMPLETE");
    fnMobileExtraClass('active-full');
  }

  fuUpdatePrice();
});

function fnPreviewClose(type){
  $("#bundle-product-product").removeClass("bundle-product-complete");
  fnMobileExtraClass('active-full');
  if(type == 1){
    $("#proChainValue").val('');
    $("#proChainPrice").val('');
    $("#proChainVariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-chain").show();
    $('.chian-close').hide();
  
    $(".chain-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Chain_Vector.png?v=1679658387");
    $(".chain-title").html("CHAIN");

    $(".chain .product_bundle_variant").val("");
  }
  else if(type == 2){
    $("#proChain2Value").val('');
    $("#proChain2Price").val('');
    $("#proChain2VariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-chain").show();
    $('.chian2-close').hide();
  
    $(".chain2-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Chain_Vector.png?v=1679658387");
    $(".chain2-title").html("CHAIN #2");
    $(".chain2 .product_bundle_variant").val("");
  }
  else if(type == 3){
    $("#proBracheletValue").val('');
    $("#proBracheletPrice").val('');
    $("#proBracheletVariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-bracelet").show();
    $('.bracelet-close').hide();
  
    $(".bracelet-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Bracelet_Vector.png?v=1679658387");
    $(".bracelet-title").html("BRACELET");
    $(".bracelet .product_bundle_variant").val("");
  }
  else if(type == 4){
    $("#proBrachelet2Value").val('');
    $("#proBrachelet2Price").val('');
    $("#proBrachelet2VariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-bracelet").show();
    $('.bracelet2-close').hide();
  
    $(".bracelet2-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Bracelet_Vector.png?v=1679658387");
    $(".bracelet2-title").html("BRACELET #2");
    $(".bracelet .product_bundle_variant").val("");
  }
  else if(type == 5){
    $("#proEarringValue").val('');
    $("#proEarringPrice").val('');
    $("#proEarringVariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-earrings").show();
    $('.earrings-close').hide();
  
    $(".earrings-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Earrings.webp?v=1679897709");
    $(".earrings-title").html("EARRINGS");
    $(".earrings .product_bundle_variant").val("");
  }
  else if(type == 6){
    $("#proRingValue").val('');
    $("#proRingPrice").val('');
    $("#proRingVariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-ring").show();
    $('.ring-close').hide();
  
    $(".ring-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Ring_Vector.png?v=1679658387");
    $(".ring-title").html("RING");
    $(".ring .product_bundle_variant").val("");
  }
  else if(type == 7){
    $("#proPendantValue").val('');
    $("#proPendantPrice").val('');
    $("#proPendantVariantId").val('');
  
    $(".bundle-product-collection").hide();
    $(".bundle-pendant").show();
    $('.pendant-close').hide();
  
    $(".pendant-media img").attr("src", "https://cdn.shopify.com/s/files/1/0733/7885/7237/files/Pendant_Vector.webp?v=1679897759");
    $(".pendant-title").html("PENDANT");
    $(".pendant .product_bundle_variant").val("");
  }
  
  fuUpdatePrice();
}

$(document).on("click", ".add-cart-custom", function () {
  var proChainVariantId = $("#proChainVariantId").val();
  var proChain2VariantId = $("#proChain2VariantId").val();
  var proBracheletVariantId = $("#proBracheletVariantId").val();
  var proBrachelet2VariantId = $("#proBrachelet2VariantId").val();
  var proEarringVariantId = $("#proEarringVariantId").val();
  var proRingVariantId = $("#proRingVariantId").val();
  var proPendantVariantId = $("#proPendantVariantId").val();

  var productArr = [];
  if (proChainVariantId != '' && typeof proChainVariantId !== "undefined" ) {
    let item = {
      quantity: 1,
      id: proChainVariantId
    };
    productArr.push(item);
  }
  if (proChain2VariantId != '' && typeof proChain2VariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proChain2VariantId
    };
    productArr.push(item);
  }
  if (proBracheletVariantId != '' && typeof proBracheletVariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proBracheletVariantId
    };
    productArr.push(item);
  }
  if (proBrachelet2VariantId != '' && typeof proBrachelet2VariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proBrachelet2VariantId
    };
    productArr.push(item);
  }
  if (proEarringVariantId != '' && typeof proEarringVariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proEarringVariantId
    };
    productArr.push(item);
  }
  if (proRingVariantId != '' && typeof proRingVariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proRingVariantId
    };
    productArr.push(item);
  }
  if (proPendantVariantId != '' && typeof proPendantVariantId !== "undefined") {
    let item = {
      quantity: 1,
      id: proPendantVariantId
    };
    productArr.push(item);
  }
  if(productArr.length > 0){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          items: productArr
      },
      dataType: 'json',
      success: function (line_item) {
        window.location.href = '/cart';
      }
    });
  }
});

function fnMobileExtraClass(cName){
  if (screen.width < 768){
    if(jQuery('.bundle-product-drawer').hasClass(cName)){
      jQuery('.bundle-product-drawer').removeClass(cName);
      jQuery('.bundle-demo-drawer > h2').removeClass(cName);
    }else{
      jQuery('.bundle-product-drawer').addClass(cName);
      jQuery('.bundle-demo-drawer > h2').addClass(cName);
    }
  }

  if(cName == 'active'){
    setTimeout(function() {
      $('.bundle-product-drawer').removeClass('active');
    },6000);
  }
}

jQuery(document).ready(function($) {
  $(".product_bundle_variant").val("");
  if (screen.width < 768){
    jQuery('.bundle-demo-drawer > h2').on('click', function(e) {
      if(jQuery('.bundle-product-drawer').hasClass('active-part')){
        jQuery('.bundle-product-drawer').removeClass('active-part');
        jQuery('.bundle-demo-drawer > h2').removeClass('active-part');
      }else{
        jQuery('.bundle-product-drawer').addClass('active-part');
        jQuery('.bundle-demo-drawer > h2').addClass('active-part');
      }
    });

    setTimeout(function() {
      $('.bundle-product-drawer').removeClass('active');
    },6000);
  }
});
function closeModel(){
  if(jQuery('.bundle-product-drawer').hasClass('active-part')){
    jQuery('.bundle-product-drawer').removeClass('active-part');
    jQuery('.bundle-demo-drawer > h2').removeClass('active-part');
  }
}